export default {
    label: [
        {
            required: true,
            message: Loc.g('Ce champ est requis'),
            trigger: 'blur',
        },
        {
            min: 2,
            max: 200,
            message: Loc.g('Doit être compris entre 2 et 200 caractères'),
        },
    ],
    line1: [
        {
            required: true,
            message: Loc.g('Veuillez sélectionner une adresse valide'),
            trigger: 'blur',
        },
        {
            min: 2,
            max: 250,
            message: Loc.g('Doit être compris entre 2 et 250 caractères'),
        },
    ],
    city: [
        {
            required: true,
            message: Loc.g('Veuillez sélectionner une ville valide'),
            trigger: 'blur',
        },
        {
            min: 2,
            max: 250,
            message: Loc.g('Doit être compris entre 2 et 250 caractères'),
        },
    ],
    postalCode: [
        {
            required: true,
            message: Loc.g('Veuillez sélectionner un code postal valide'),
            trigger: 'blur',
        },
        {
            min: 2,
            max: 30,
            message: Loc.g('Doit être compris entre 2 et 30 caractères'),
        },
    ],
    country: [
        {
            required: true,
            message: Loc.g('Veuillez sélectionner un pays valide'),
            trigger: 'blur',
        },
        {
            min: 2,
            max: 250,
            message: Loc.g('Doit être compris entre 2 et 250 caractères'),
        },
    ],
};
